import axios from "axios";
import { Dispatch } from "redux";
import { RawAnswer, PreparedSociometryTest } from "shared/types/sociometry";
import { showAlert } from "./setAppActions";
import {
    SOCIOMETRY_LOAD_TEST,
    SOCIOMETRY_LOAD_TEST_SUCCESS,
    SOCIOMETRY_LOAD_TEST_FAILURE,
    SOCIOMETRY_SELECT_ANSWER,
    SOCIOMETRY_NEXT_QUESTION,
    SOCIOMETRY_PREV_QUESTION,
    SOCIOMETRY_SUBMIT_START,
    SOCIOMETRY_SUBMIT_SUCCESS,
    SOCIOMETRY_SUBMIT_FAILURE,
    SOCIOMETRY_RESET,
    SociometryActionTypes,
} from "../sociometryReducer";

export const loadSociometryTest = (sessionId: string) => {
    return async (dispatch: Dispatch<SociometryActionTypes | any>) => {
        dispatch({ type: SOCIOMETRY_LOAD_TEST });

        try {
            const { data } = await axios.get<PreparedSociometryTest>(`sociometry/session/${sessionId}/test`);

            dispatch({
                type: SOCIOMETRY_LOAD_TEST_SUCCESS,
                payload: data,
            });
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || "Failed to load test";
            dispatch({
                type: SOCIOMETRY_LOAD_TEST_FAILURE,
                payload: message,
            });
            dispatch(showAlert({ type: "error", text: message }));
        }
    };
};

export const selectAnswer = (questionIndex: number, isPositive: boolean, chosen: string[]) => {
    return {
        type: SOCIOMETRY_SELECT_ANSWER,
        payload: {
            questionIndex,
            isPositive,
            chosen,
        } as RawAnswer,
    };
};

export const nextQuestion = () => {
    return {
        type: SOCIOMETRY_NEXT_QUESTION,
    };
};

export const prevQuestion = () => {
    return {
        type: SOCIOMETRY_PREV_QUESTION,
    };
};

export const submitAnswers = (sessionId: string, pupilId: string, answers: RawAnswer[]) => {
    return async (dispatch: Dispatch<SociometryActionTypes | any>) => {
        dispatch({ type: SOCIOMETRY_SUBMIT_START });

        try {
            await axios.post(`/sociometry/session/${sessionId}/answer`, {
                pupilId,
                answers,
            });

            dispatch({ type: SOCIOMETRY_SUBMIT_SUCCESS });
            dispatch({ type: SOCIOMETRY_RESET });

            return true;
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || "Failed to submit answers";
            dispatch({
                type: SOCIOMETRY_SUBMIT_FAILURE,
                payload: message,
            });
            dispatch(showAlert({ type: "error", text: message }));
            return false;
        }
    };
};

export const resetSociometry = () => {
    return {
        type: SOCIOMETRY_RESET,
    };
};
